import { SeriesSourceRegistry } from '@/lib/tradingview/datafeeds/series-sources'

import {
  crossExchangeCvdSource,
  crossExchangeFundingRateSource,
  crossExchangeOpenInterestSource,
} from './cross-exchange-source'
import { optionsVolumeSeriesSource } from './options-volume-source'
import { orderbookMetricsSeriesSource } from './orderbook-metrics-source'
import { putCallRatioSeriesSource } from './put-call-ratio-source'
import { skewSeriesSource } from './skew-source'

/**
 * All own-fetch series sources the TV chart ships with. Add-a-series recipe
 * (the options-OI exemplar): author one ChartSeriesSource descriptor next to
 * this file + one ChartAnalyticsDefinition carrying `source`, then register
 * the descriptor here. No core (manager / datafeed routing / family-mask /
 * study-lifecycle) edits — see __tests__/series-source-pluggability.test.ts.
 */
export function createDefaultSeriesSourceRegistry(): SeriesSourceRegistry {
  const registry = new SeriesSourceRegistry()
  registry.register(putCallRatioSeriesSource)
  registry.register(skewSeriesSource)
  registry.register(optionsVolumeSeriesSource)
  registry.register(orderbookMetricsSeriesSource)
  registry.register(crossExchangeOpenInterestSource)
  registry.register(crossExchangeFundingRateSource)
  registry.register(crossExchangeCvdSource)
  return registry
}
